import React from 'react';
import './Sub-services.css'; // Importa los estilos CSS para este componente
import planos from './assets/Diagrama.png';
const PlanosElectricosContent = () => {
  return (
    <div className="containerSer">
      <h2>Planos Eléctricos y Diagramas Unifilares</h2>
      <p>
        Los planos eléctricos y diagramas unifilares son representaciones gráficas esenciales para el diseño, ejecución y legalización de cualquier instalación eléctrica. Permiten visualizar de forma clara el recorrido de los circuitos, la ubicación de equipos, protecciones, puntos de conexión facilitando procesos de construcción, de mantenimiento y certificación.
      </p>
       <div className="image">
        <img src={planos} alt="Planos electricos y diagramas unifilares" />
      </div>
      <p>
        Ofrecemos el servicio de diseño de planos eléctricos y diagramas unifilares según los requerimientos técnicos de cada proyecto, dando cumplimiento a la norma; este servicio incluye: Recolección de información técnica del sitio, diseño de planos eléctricos en formato digital y físico (si se requiere); Elaboración de diagramas unifilares para sistemas eléctricos convencionales y fotovoltaicos, revisión técnica conforme a la normativa vigente, entrega de archivos en formatos editables y PDF.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Facilita la correcta ejecución de las instalaciones.</li>
        <li>Mejora el mantenimiento y diagnóstico de sistemas eléctricos.</li>
        <li>Soporte técnico para la legalización y validación de proyectos.</li>
        <li>Tranquilidad y confianza al contar con documentación profesional, clara y conforme a norma.</li>
      </ul>
    </div>
  );
};

export default PlanosElectricosContent;
